// Маппинг ID языка в код для Google Translate
export const languageMapping = {
    0: { code: 'ru', flag: '🇷🇺' },
    1: { code: 'be', flag: '🇧🇾' },
    2: { code: 'kk', flag: '🇰🇿' },
    3: { code: 'hy', flag: '🇦🇲' },
    4: { code: 'ky', flag: '🇰🇬' },
    5: { code: 'uz', flag: '🇺🇿' },
    6: { code: 'en', flag: '🇺🇸' },
    7: { code: 'fr', flag: '🇫🇷' },
    8: { code: 'es', flag: '🇪🇸' },
    9: { code: 'hi', flag: '🇮🇳' },
};